// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_b2u1W"};